export default [
  {
    path: '/logistics/legal-persons-stats',
    name: 'pageLegalPersonsStats',
    meta: { title: 'page.pageLegalPersonsStats', roles: ['LOGISTIC_ORGANIZATION_REPORT'] },
    component: () => import('@/pages/logistics/legal-persons-stats'),
  },
]
